/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListExportFormatsResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ListExportFormatsResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/exports/formats
 */
export interface FormatsRequestBuilder extends BaseRequestBuilder<FormatsRequestBuilder> {
    /**
     * Lists the export formats available to the caller's organization: the built-in file types (CSV, Tab Delimited, JSON, SAP) plus any custom multi-file formats the organization has been enabled for. Send the returned ExportFileType for a built-in, or CustomFormatKey for a custom format, on POST api/exports/orders/by-id. Custom formats download as a zip.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListExportFormatsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListExportFormatsResponse | undefined>;
    /**
     * Lists the export formats available to the caller's organization: the built-in file types (CSV, Tab Delimited, JSON, SAP) plus any custom multi-file formats the organization has been enabled for. Send the returned ExportFileType for a built-in, or CustomFormatKey for a custom format, on POST api/exports/orders/by-id. Custom formats download as a zip.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FormatsRequestBuilderUriTemplate = "{+baseurl}/api/exports/formats";
/**
 * Metadata for all the requests in the request builder.
 */
export const FormatsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: FormatsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListExportFormatsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
